import { AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/Button';

const reloadPage = () => window.location.reload();

/**
 * Full-page fallback for the app-level Sentry ErrorBoundary. Reached when a
 * render error surfaces past every recovery layer — most commonly a lazy route
 * chunk that failed to fetch even after lazyRoute's one-shot automatic reload
 * (flaky network, blocked request). A full reload is the only real recovery
 * here: React caches a rejected lazy() import for the lifetime of the
 * document, so re-rendering via Sentry's resetError would just re-throw.
 */
export function AppErrorFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background-subtle px-6">
      <div className="text-center max-w-md">
        <AlertCircle className="h-12 w-12 text-destructive mx-auto mb-4" />
        <h1 className="text-heading mb-2">Something went wrong</h1>
        <p className="text-body-small mb-6">
          An unexpected error kept this page from loading. Reloading usually
          fixes it. If the problem continues,{' '}
          <a
            href="https://expectedhealthcare.com/contact-us"
            target="_blank"
            rel="noreferrer"
            className="text-link underline"
          >
            contact us
          </a>
          .
        </p>
        <Button size="lg" onClick={reloadPage}>
          Reload page
        </Button>
      </div>
    </div>
  );
}
